import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface CommandBarState {
  isOpen: boolean;
  query: string;
}

const initialState: CommandBarState = {
  isOpen: false,
  query: '',
};

const commandBarSlice = createSlice({
  name: 'commandBar',
  initialState,
  reducers: {
    openCommandBar(state) {
      state.isOpen = true;
    },
    closeCommandBar(state) {
      state.isOpen = false;
      state.query = '';
    },
    toggleCommandBar(state) {
      state.isOpen = !state.isOpen;
      if (!state.isOpen) {
        state.query = '';
      }
    },
    setQuery(state, action: PayloadAction<string>) {
      state.query = action.payload;
    },
  },
});

export const { openCommandBar, closeCommandBar, toggleCommandBar, setQuery } =
  commandBarSlice.actions;
export const commandBarReducer = commandBarSlice.reducer;
export default commandBarSlice;
